import { render, staticRenderFns } from "./newfloor.vue?vue&type=template&id=794f69c3&scoped=true"
import script from "./newfloor.vue?vue&type=script&lang=js"
export * from "./newfloor.vue?vue&type=script&lang=js"
import style0 from "./newfloor.vue?vue&type=style&index=0&id=794f69c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794f69c3",
  null
  
)

export default component.exports